import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FacilityBillingService } from 'src/app/facility-contracts/facility-billing.service';
import { ProfessionsAndExpertiseService } from 'src/app/shared/services/professions-and-expertise.service';
import { Expertise } from 'src/app/shared/models/expertise.model';
import { Profession } from 'src/app/shared/models/profession.model';
import { ToasterService } from 'src/app/shared/services/toaster.service';
import { MatLegacySelect as MatSelect } from '@angular/material/legacy-select';
import { MatLegacyOption as MatOption } from '@angular/material/legacy-core';
import { FacilityProfession } from 'src/app/facility-contracts/facilities/models/facility-profession.model';
import { isEmpty } from 'src/app/shared/utilities/obj-utilities';

@Component({
    selector: 'nova-edit-profession-dialog',
    templateUrl: './edit-profession-dialog.component.html',
    styleUrls: ['./edit-profession-dialog.component.scss']
})
export class EditProfessionDialogComponent implements OnInit {
    @ViewChild('expSel')
    expSel: MatSelect;

    title = 'Edit Profession';
    saveButtonTitle = 'Update Profession';

    isLoading = false;
    isEdit: boolean;
    isSaving: boolean;
    allSelected = false;

    expertisesReloadSubject$ = new BehaviorSubject(true);
    professionsReloadSubject$ = new BehaviorSubject(true);

    profession: FacilityProfession;
    selectedExpertises: any[];

    professions$: Observable<Profession[]>;
    expertises$: Observable<Expertise[]>;

    constructor(
        private readonly service: FacilityBillingService,
        private readonly professionsAndExpertiseService: ProfessionsAndExpertiseService,
        private readonly toasterService: ToasterService,
        private readonly dialogRef: MatDialogRef<EditProfessionDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private readonly data: { facilityId: number; profession: FacilityProfession }
    ) {
        if (data !== null && data.profession !== null) {
            this.profession = data.profession;

            this.isEdit = data.profession.id > 0;
            this.title = data.profession.id > 0 ? 'Edit Profession' : 'Add Profession';
            this.saveButtonTitle = data.profession.id > 0 ? 'Update Profession' : 'Add Profession';
            this.isSaving = false;

            if (this.isEdit && data.profession.expertises !== null && data.profession.expertises !== undefined) {
                this.selectedExpertises = [];
                data.profession.expertises.forEach((x) => {
                    this.selectedExpertises.push(x.id);
                });
            }
        }
    }

    ngOnInit(): void {
        this.professions$ = this.professionsReloadSubject$.pipe(
            switchMap(() => this.professionsAndExpertiseService.getProfessions())
        );

        this.expertises$ = this.expertisesReloadSubject$.pipe(
            switchMap(() => this.professionsAndExpertiseService.getExpertiseForProfession(this.profession.professionId))
        );
    }

    toggleAllSelection(): void {
        this.allSelected = !this.allSelected;

        if (this.allSelected) {
            this.expSel.options.forEach((item: MatOption) => item.select());
        } else {
            this.expSel.options.forEach((item: MatOption) => {
                item.deselect();
            });
        }
    }

    professionChanged(): void {
        this.selectedExpertises = [];
        this.expertisesReloadSubject$.next(true);
    }

    professionAndExpertisesEmptyError(): boolean {
        return (
            !isEmpty(this.profession) &&
            (this.profession.professionId === 0 || (this.selectedExpertises && this.selectedExpertises.length === 0))
        );
    }

    save(): void {
        this.isSaving = true;
        this.profession.expertises = this.selectedExpertises;
        if (this.isEdit) {
            this.service.updateProfession(this.data.facilityId, this.profession.id, this.profession).subscribe({
                next: () => {
                    this.toasterService.toast('Saved successfuly.');
                    this.dialogRef.close(true);
                },
                error: () => {
                    this.toasterService.toast('An error occurred while saving.');
                }
            });
        } else {
            this.service.addProfession(this.data.facilityId, this.profession).subscribe({
                next: () => {
                    this.toasterService.toast('Saved successfuly.');
                    this.dialogRef.close(true);
                },
                error: () => {
                    this.toasterService.toast('An error occurred while saving.');
                }
            });
        }
    }

    close(result: boolean): void {
        this.dialogRef.close(result);
    }
}
